import store from '@/store';

const openModal = async (msg, alertType, url, confirmOkHandler) => {
  await store.dispatch('modalObject', {
    msg,
    alertType,
    url,
    confirmOkHandler,
  });
};

const checkModal = async (msg, url, confirmOkHandler) => {
  await store.dispatch('modalObject', {
    msg,
    alertType: 'check',
    url,
    confirmOkHandler,
  });
};

const warningModal = async (msg, url, confirmOkHandler) => {
  await store.dispatch('modalObject', {
    msg,
    alertType: 'warning',
    url,
    confirmOkHandler,
  });
};

const confirmModal = async (
  msg,
  url,
  confirmOkHandler,
  confirmCancelMessage,
  confirmOkMessage,
) => {
  await store.dispatch('modalObject', {
    msg,
    alertType: 'confirm',
    url,
    confirmOkHandler,
    confirmCancelMessage,
    confirmOkMessage,
  });
};

export { openModal, checkModal, warningModal, confirmModal };
